import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ValidatorForm } from 'react-form-validator-core';
import { TFVButton, TextField, Translate } from '../../../Share/components';
import { useDispatch } from 'react-redux';
import { setNewPassword } from '../../actions/authentication';
import './style.scss';
import decrypt from '../../../Share/utils/cryptoUtil';
import { passwordPolicyCheck } from '../../../Share/utils';

const SetNewPassword = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const formRef = useRef(null);

  const [state, setState] = useState({
    customerNumber: '',
    password: '',
    retypePassword: '',
    accessToken: '',
    errorMessage: '',
    isSubmitButtonClick: false,
    submitDisabled: false,
  });

  useEffect(() => {
    ValidatorForm.addValidationRule('isReTypePasswordMatch', value => {
      if (!state.isSubmitButtonClick) return true;
      return value === state.password;
    });

    ValidatorForm.addValidationRule('passwordPolicy', value => {
      if (!state.isSubmitButtonClick) return true;
      const { isValid, errorMessage } = passwordPolicyCheck(value);
      setState(prev => ({ ...prev, errorMessage }));
      return isValid;
    });

    handleParseUrl();
  }, [state.isSubmitButtonClick, state.password]);

  const handleParseUrl = () => {
    const params = new URLSearchParams(location.search);
    const encodedData = params.get('data');

    if (encodedData) {
      const encryptedData = decodeURIComponent(encodedData).replace(/\s/g, '+');
      const plaintextData = decrypt(encryptedData);
      const paramsParser = new URLSearchParams(plaintextData);

      const customerNumber = paramsParser.get('customer_id');
      const accessToken = paramsParser.get('token');

      if (customerNumber && accessToken) {
        setState(prev => ({
          ...prev,
          customerNumber,
          accessToken,
        }));
      }
    }
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setState(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleValidate = () => {
    const { isValid } = passwordPolicyCheck(state.password || '');
    return isValid && state.retypePassword === state.password;
  };

  const handleSubmit = e => {
    setState(prev => ({ ...prev, isSubmitButtonClick: true }));

    if (handleValidate()) {
      const { customerNumber, password, accessToken } = state;
      dispatch(setNewPassword(customerNumber, password, accessToken));
    }
  };

  return (
    <div className="tv-login__wrapper tv-display-flex">
      <div className=" tv-login__form tv-login__form-wrapper">
        <div className="tv-set-new-password__title">
          <Translate content="login.newPassword" />
        </div>
        <div className="tv-set-new-password__description">
          <Translate content="login.passwordPolicyText" />
        </div>
        <div className="tv-set-new-password__form tv-set-new-password__form-wrapper">
          <ValidatorForm ref={formRef} onSubmit={() => {}}>
            <label htmlFor="password" className="tv-login__form-label">
              <Translate content="login.enterNewPassword" />
            </label>
            <TextField
              type="password"
              onChange={handleChange}
              className="tx-input-text"
              name="password"
              id="password"
              value={state.password}
              placeholder={Translate({ content: 'login.enterNewPassword' })}
              validators={['required', 'passwordPolicy']}
              errorMessages={['', state.errorMessage]}
            />

            <label htmlFor="retypePassword" className="tv-login__form-label">
              <Translate content="login.retypeNewPassword" />
            </label>
            <TextField
              type="password"
              onChange={handleChange}
              className="tx-input-text"
              name="retypePassword"
              id="retypePassword"
              value={state.retypePassword}
              placeholder={Translate({ content: 'login.retypeNewPassword' })}
              validators={['required', 'isReTypePasswordMatch']}
              errorMessages={[
                Translate({
                  content: 'validator.isNotValid',
                  params: {
                    name: Translate({ content: 'general.repeatPassword' }),
                  },
                }),
                Translate({ content: 'validator.passwordMatch' }),
              ]}
            />

            <TFVButton
              type="primary"
              buttonType="submit"
              text={Translate({ content: 'login.changePassword' })}
              className="tv-set-new-password__form-submit"
              onClick={handleSubmit}
            />
          </ValidatorForm>
        </div>
      </div>
    </div>
  );
};

export default SetNewPassword;
